import React, { useState, useContext, useEffect, useRef } from "react";
import { Info } from "phosphor-react";
import { MapActions, MapContext } from "context/map";
import useOnClickOutside from "hooks/useOnClickOutside";
import "./index.scss";

const MapInspect = () => {
  const tooltipRef = useRef();
  const { state, dispatch } = useContext(MapContext);
  const { inspect } = state;
  const [tooltip, setTooltip] = useState(true);
  useOnClickOutside(tooltipRef, () => setTooltip(false));

  useEffect(() => {
    const divs = [
      ".map-settings",
      ".timeline-wrapper",
      ".map-options",
      ".measure-tools",
    ];
    const divRefs = divs.map((selector) => document.querySelector(selector));

    const disableInspect = (e) => {
      if (e.target.closest(divs)) {
        dispatch({ type: MapActions.SET_INSPECT, value: false });
      }
    };

    if (inspect) {
      divRefs.forEach((div) => {
        div.addEventListener("click", disableInspect);
      });
    }

    return () => {
      if (inspect) {
        divRefs.forEach((div) => {
          div.removeEventListener("click", disableInspect);
        });
      }
    };
  }, [dispatch, inspect]);

  useEffect(() => {
    const map = document.querySelector(".mapboxgl-map");

    if (inspect) {
      map.classList.add("-inspect");
    }

    return () => {
      map.classList.remove("-inspect");
    };
  }, [inspect]);

  useEffect(() => {
    const tooltipButton = document.querySelector(".inspect-button");

    tooltipButton.addEventListener("mouseenter", () => {
      setTooltip(true);
    });
    tooltipButton.addEventListener("mouseleave", () => {
      setTooltip(false);
    });
  }, []);

  return (
    <div className="map-inspect" ref={tooltipRef}>
      {tooltip && (
        <div className="inspect-tooltip">
          <h1 className="title">Inspect tool</h1>
          <p className="text">Click on zones to view more forecast details.</p>
        </div>
      )}
      <button
        type="button"
        data-tip
        data-for="inspect-tip"
        className={`inspect-button ${inspect ? "-active" : ""}`}
        onClick={() => {
          dispatch({
            type: "SET_INSPECT",
            value: !inspect,
          });
        }}
      >
        <Info size={22} />
      </button>
    </div>
  );
};

export default MapInspect;
